module.exports = __webpack_public_path__ + "static/media/loadtest.ad091915.png";